import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CustomerService } from 'gung-standard';
import { first } from 'rxjs';
import { ColmecDashboardDataService } from '../../services/colmec-dashboard-data.service';

@Component({
    selector: 'colmec-salesperson-select',
    templateUrl: './colmec-salesperson-select.component.html',
    styleUrls: ['./colmec-salesperson-select.component.scss'],
    standalone: false
})
export class ColmecSalespersonSelectComponent implements OnInit {
  myFormGroup: any;
  saljare: string;
  saljareToCustomerIds: any;
  constructor(
    protected dashboardDataService: ColmecDashboardDataService,
    protected customerService: CustomerService,
    protected formBuilder: FormBuilder
  ) {
    this.saljare = dashboardDataService.selectedSalesPerson;
    this.saljareToCustomerIds = {};

    this.customerService
      .getCustomers()
      .pipe(first())
      .subscribe(customers => {
        console.log('CUSTOMERS', customers);
        customers.forEach(e => {
          const saljare = e.extra.kus.saljare;
          this.saljareToCustomerIds[saljare] = this.saljareToCustomerIds[saljare] || [];
          this.saljareToCustomerIds[saljare].push(e.id);
        });
        this.saljareToCustomerIds.ANÅH = ['1543'];
        console.log('CUSTOMERS MAPPED', this.saljareToCustomerIds);
      });
  }

  ngOnInit(): void {
    this.myFormGroup = this.formBuilder.group({
      saljare: [{ disabled: false, value: this.saljare || '' }]
    });
  }

  salesPersonSelected(event) {
    let filter = null;
    this.dashboardDataService.selectedSalesPerson = event;
    console.log('salesPersonSelected [event]', event);
    if (event) {
      const customerIds = this.saljareToCustomerIds[event];
      if (customerIds) {
        filter = { required: { customerId: customerIds } };
      } else {
        filter = { required: { customerId: [] } };
      }
    }

    console.log('salesPersonSelected [filter]', filter);
    this.dashboardDataService.setFilter(filter);
  }
}
